import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Mental Health:',
    subLabel: '',
    field: 'WLPreSWMentalHealth',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Have you ever been diagnosed with a mental health condition? If yes, please provide details:',
            type: 'single_select',
          options: [
            {
              key: 'diagnosedYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'diagnosedMentalHealthCondition',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'diagnosedNo', value: 'No' }
          ]
        },
        {
          label:
            'Are you currently receiving any mental health treatment or therapy? If yes, please provide details:',
          type: 'single_select',
          options: [
            {
              key: 'treatementYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'MHtreatmentOrTherapy',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'treatementNo', value: 'No' }
          ]
        },
        {
          label:
            'How would you rate your current mental well-being on a scale of 1 to 10, with 1 being extremely poor and 10 being excellent?',
          type: 'text',
          level: 'top',
          name: 'WLPreSWcurrentState',
          rows: 1
        },
        {
          label:
            'Have you experienced significant stress, anxiety, or depression related to your weight or body image? If yes, please describe:',
          type: 'single_select',
          options: [
            {
              key: 'bodyImageYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'relatedToBodyImage',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'bodyImageNo', value: 'No' }
          ]
        }
      ]
    }
  },
  {
    label: 'Social Support:',
    subLabel: '',
    field: 'WLPreSWSocialSupport',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Do you have a support system (e.g., family, friends) to help you with your weight loss journey?',
          type: 'single_select',
          options: [
            {
              key: 'supportSystemYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'supportSystemPeople',
                    placeholder: 'Who?'
                  }
                ]
              }
            },
            { key: 'supportSystemNo', value: 'No' }
          ]
        },
        {
          label:
            'Are there any challenges or obstacles you anticipate in following a weight loss management program?',
          type: 'single_select',
          options: [
            {
              key: 'challengesAnticipatedYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'challengesAnticipated',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'challengesAnticipatedNo', value: 'No' }
          ]
        }
      ]
    }
  },
  {
    label: 'Depression Assessment:',
    subLabel: '',
    field: 'WLPreSWDepressionAssessment',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Over the past two weeks, have you experienced persistent feelings of sadness, hopelessness, or a lack of interest or pleasure in activities you used to enjoy?',
          type: 'single_select',
          options: [
            {
              key: 'feelingsOfSadnessYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'feelingsOfSadness',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'feelingsOfSadnessNo', value: 'No' }
          ]
        },
        {
          label:
            'Have you noticed significant changes in your appetite, sleep patterns, or energy levels?',
          type: 'single_select',
          options: [
            {
              key: 'appetiteChangesYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'appetiteChanges',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'appetiteChangesNo', value: 'No' }
          ]
        }
      ]
    }
  },
  {
    label: 'Anxiety Assessment:',
    subLabel: '',
    field: 'WLPreSWAnxietyAssessment',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Have you experienced excessive worrying, restlessness, irritability, or feeling on edge most days over the past six months?',
          type: 'single_select',
          options: [
            {
              key: 'excessiveWorryingYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'excessiveWorrying',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'excessiveWorryingNo', value: 'No' }
          ]
        },
        {
          label:
            'Have you noticed physical symptoms such as rapid heartbeat, shortness of breath, sweating, or trembling during periods of anxiety?',
          type: 'single_select',
          options: [
            {
              key: 'tremblingYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'tremblingSymptoms',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'tremblingNo', value: 'No' }
          ]
        },
        {
          label:
            'Have these symptoms caused significant distress or interference with your daily life?',
          type: 'single_select',
          options: [
            {
              key: 'distressYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'distressOrInterference',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'distressNo', value: 'No' }
          ]
        }
      ]
    }
  },
  {
    label: 'Emotional Eating:',
    subLabel: '',
    field: 'WLPreSWEmotionalEating',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Do you tend to eat in response to emotions such as stress, sadness, anxiety, or boredom?',
          type: 'single_select',
          options: [
            { key: 'EatingResponseYes', value: 'Yes' },
            { key: 'EatingResponseNo', value: 'No' }
          ]
        },
        {
          label:
            'How frequently do you engage in emotional eating or eating as a way to cope with emotions?',
          type: 'text',
          level: 'top',
          name: 'WLPreSWfrequency',
          rows: 1
        },
        {
          label:
            'Can you identify any specific triggers or situations that lead to emotional eating episodes?',
          type: 'single_select',
          options: [
            {
              key: 'identifyTriggersYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'identifyTriggers',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'identifyTriggersNo', value: 'No' }
          ]
        },
        {
          label:
            'Are there any patterns or behaviors you engage in during emotional eating episodes (e.g., binge eating, eating in secret)?',
          type: 'single_select',
          options: [
            {
              key: 'patternsOrBehaviorsYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'patternsOrBehaviors',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'patternsOrBehaviorsNo', value: 'No' }
          ]
        },
        {
          label:
            'Have you tried any strategies in the past to manage emotional eating? If so, please provide details about their effectiveness.',
          type: 'single_select',
          options: [
            {
              key: 'strategiesToManageYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'strategiesToManage',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'strategiesToManageNo', value: 'No' }
          ]
        },
        {
          label: 'How do you typically manage or cope with stress?',
          type: 'text',
          level: 'top',
          name: 'WLPreSWcopingWithStress',
          rows: 1
        },
        {
          label:
            'Are there any particular sources of stress in your life currently that you would like to discuss?',
          type: 'single_select',
          options: [
            {
              key: 'stressorsToDiscussYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'stressorsToDiscuss',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'stressorsToDiscussNo', value: 'No' }
          ]
        },
        {
          label:
            'Are you open to learning new strategies and techniques to manage stress and emotions effectively, as part of this weight loss management program?',
          type: 'single_select',
          options: [
            { key: 'newStrategiesYes', value: 'Yes' },
            { key: 'newStrategiesNo', value: 'No' }
          ]
        }
      ]
    }
  },
  {
    label: 'Goals and Expectations:',
    subLabel: '',
    field: 'WLPreSWGoals',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'What are your primary goals for speaking to a social worker?',
          type: 'text',
          name: 'WLPreSWprimaryGoals',
          rows: 1
        },
        {
          label:
            'What are your expectations from a social work perspective in this program?',
          type: 'text',
          name: 'WLPreSWexpectations',
          rows: 1
        },
        {
          label:
            'How would you define success in terms of your mental health goals?',
          type: 'text',
          name: 'WLPreSWdistress',
          rows: 1
        }
      ]
    }
  }
];
export default questionsModels;
